import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { FilterMatchesPage } from './filter-matches/filter-matches.page';
import { environment } from '../../environments/environment';
import { Device } from '@ionic-native/device/ngx';
import { DailyCheckInBonusPage } from './daily-check-in-bonus/daily-check-in-bonus.page';
import { API } from 'aws-amplify';
import { Subject, Subscription } from 'rxjs';
import { CricketPage } from './cricket/cricket.page';
import { HelperService } from '../shared/services/helper_service';
import { AuthService } from '../shared/services/auth_service';
import { HttpClient } from '@angular/common/http';
import { AppUpdatePage } from '../app-update/app-update.page';

@Component({
  selector: 'app-lobbypage',
  templateUrl: './lobbypage.page.html',
  styleUrls: ['./lobbypage.page.scss'],
})
export class LobbypagePage implements OnInit, OnDestroy {
  public env = environment;
  language: string;
  status = 'live';
  match = "cricket"
  Namma11CupLogo = '/mobile/logos/appcuplogo.png';
  cacheCleartimestamp : number = new Date().getTime();
  // images = [
  //   {path: `${environment.s3AssetsUrl}/site/images/banner+1.png`},
  //   {path: `${environment.s3AssetsUrl}/site/images/banner+2.png`},
  //   {path: `${environment.s3AssetsUrl}/site/images/banner+3.png`},
  //   {path: `${environment.s3AssetsUrl}/site/images/banner+4.png`},
  // ]

  filterArray: any[] = [];
  matchData: any;
  getmatchInformation: any;
  selectedFilter: any[] = [];
  flag: boolean = true;
  flag2: boolean = false;
  notificationsUnread: any;
  allowClaim :number;
  dailystreaklist : any;
  alreadyClaimed : number;
  private pauseListener: Subscription;
  private resumeListener: Subscription;
  ionViewWillEnterSubject: Subject<boolean> = new Subject<boolean>();
  currentTimeInSeconds: number = new Date().getTime();
  filteredMatches: any[] = [];

  @ViewChild(CricketPage, { static: false }) private cricketComponent: CricketPage;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private device: Device,
    public location: Location,
    public modelCtrl: ModalController,
    private platform: Platform,
    private auth: AuthService,
    public activatedRoute: ActivatedRoute,
    private httpClient: HttpClient,
    public alertController: AlertController
  ) { }

  ionViewWillEnter() {
    this.cacheCleartimestamp  = new Date().getTime();
    this.selectedFilter = [];
    this.getMatchesSeries();
    
    // this.ionViewWillEnterSubject.next(true);
    this.cricketComponent.doRefresh();
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }

    this.getNotificationsUnreadCount();

    this.resumeListener = this.platform.resume.subscribe(() => {
      // this.helperServis.presentToast('Refreshing on resume!!');
      this.cricketComponent.doRefresh();
    });
  }

  ionViewDidEnter(){
    this.getMatchesSeries();
  }
 
  getMatchesSeries() {
    // console.log("call getMatches1");
    const apiName = 'matchesApi';
    const path = `/matches/?${this.currentTimeInSeconds}&gameId=1&sportId=1`;
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {}
    };
    API.get(apiName, path, myInit).then((data) => {
       this.filteredMatches = data?.data?.data?.matches;
       for (let i = 0; i < this.filteredMatches.length; i++) {
        if (this.filterArray.indexOf(this.filteredMatches[i].series) === -1) {
          this.filterArray.push(this.filteredMatches[i].series);
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }


  ionViewWillLeave() {
    // this.selectedFilter = [];
    this.filterArray = [];
    console.log(this.selectedFilter)
    // this.ionViewWillEnterSubject.next(false);
    this.cricketComponent.ngOnDestroy();

    if (this.resumeListener) {
      this.resumeListener.unsubscribe();
      this.resumeListener = null;
    }
  }

  ngOnInit() {
    console.log("deviceInfo", this.device);    
    this.getDailyStrekcoins();
  }

  getDailyStrekcoins(){
    const apiName = 'profile';
    const path = `/profiles/daily-streak `;
    const myInit = {
        headers: {},
        response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        console.log(response);
        this.dailystreaklist = response.data.data ;
        this.allowClaim = response.data.data.allowClaim;
        this.alreadyClaimed = response.data.data.alreadyClaimed
        console.log(this.allowClaim);
        if(this.allowClaim && !this.alreadyClaimed){
          this.dailyCheckIn()
        }else{
          console.log("Already Claimed");
        }
        
      })
      .catch(error => {
        console.log(error);
      });    
  }

  async dailyCheckIn() {
    const model = await this.modelCtrl.create({
      component: DailyCheckInBonusPage,
      backdropDismiss: false,
      showBackdrop: true,
      cssClass: 'dailyCheckIn',
      componentProps: {dailystreaklist :this.dailystreaklist},
      //backdropDismiss: false
    });
    model.onDidDismiss();
    await model.present();
  }

  // GetChildData(data) {
  //   console.log(data);
  //   this.filterArray = [];
  //   this.filterArray = data;
  // }

  openNotificationsPage(event) {
    event.stopPropagation();
    if (this.notificationsUnread?.count) {
      this.getNotificationsUnreadCountMarkRead();
    }
    this.router.navigate(['notifications']);
  }

  getNotificationsUnreadCount() {
    const apiName = 'profile';
    const path = "/profiles/notifications/unread-count";
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        //startKey: 10
      },
    };
    this.auth.getReq(apiName, path, myInit).then((data) => {
      this.notificationsUnread = data.data.data;
    }).catch((error) => {
      console.log(error);
    });
  }

  getNotificationsUnreadCountMarkRead() {
    console.log("notificationsMarkRead");
    const apiName = 'profile';
    const path = "/profiles/notifications/mark-read";
    const myInit = {
      headers: {},
      response: true,
      body: {},
    };
    API.post(apiName, path, myInit).then((data) => {
      console.log(data);
      let unread = data.data;
      console.log("MarkRead", unread);
    }).catch((error) => {
      console.log(error);
    });
  }

  async openFilterMathes(ev: any) {
    this.getMatchesSeries();
    ev.stopPropagation();
    console.log("filterpage--",this.filterArray);
    
    const model = await this.modelCtrl.create({
      component: FilterMatchesPage,
      showBackdrop: true,
      cssClass: 'modal-class1 ion-backdrop-fullwidth-modal',
      backdropDismiss: true,
      componentProps: {selectedArray: this.selectedFilter }
    });
    model.onDidDismiss()
      .then((data) => {
        // this.matchData = this.getmatchInformation['matches'];
        console.log(data.data);
        this.selectedFilter = data.data ? data.data.length ? data.data : [] : this.selectedFilter;
      });
    await model.present();
  }

  public backClick(): void {
    this.location.back();
  }

  // segmentChanged(event) {
  //   if (this.match == "cricket") {
  //     this.flag = true;
  //     this.flag2 = false
  //   } else {
  //     this.flag = false;
  //     this.flag2 = true;
  //   }
  //   console.log(this.match);
  //   console.log(event);
  // }

  ngOnDestroy() {
    this.filterArray = [];
  }
}

